import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GridOnIcon from '@mui/icons-material/GridOn';
import LogoutIcon from '@mui/icons-material/Logout';
import AddIcon from '@mui/icons-material/Add';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import SubtitlesOffIcon from '@mui/icons-material/SubtitlesOff';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import SettingsIcon from '@mui/icons-material/Settings';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import SearchIcon from '@mui/icons-material/Search';
import BeenhereOutlinedIcon from '@mui/icons-material/BeenhereOutlined';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import AppsIcon from '@mui/icons-material/Apps';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ReportIcon from '@mui/icons-material/Report';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StorefrontIcon from '@mui/icons-material/Storefront';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from '@mui/icons-material/Download';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import RemoveIcon from "@mui/icons-material/Remove";
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/PrintRounded'
import SyncIcon from '@mui/icons-material/SyncAltRounded'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import { FaList } from 'react-icons/fa';
import { SiRazorpay } from "react-icons/si";
import { PiStudent } from "react-icons/pi";

export const WSIcons = {
  Edit: EditOutlinedIcon,
  Delete:DeleteIcon,
  Remove:RemoveIcon,
  Home: HomeIcon,
  Person: PersonIcon,
  TrendingUp: TrendingUpIcon,
  Annual: DashboardIcon,
  Masters: GridOnIcon,
  LogOut: LogoutIcon,
  AddIcon: AddIcon,
  UserGroup: GroupAddIcon,
  RolesIcon: RoomPreferencesIcon,
  ManageAccountIcon: ManageAccountsIcon,
  MedicalServicesIcon: MedicalServicesIcon,
  WithoutPay: SubtitlesOffIcon,
  ArrowRight: KeyboardArrowRightIcon,
  PersonOffIcon: PersonOffIcon,
  PickupVanIcon:AirportShuttleIcon,
  SettingsIcon:SettingsIcon,
  HolidayVillageIcon:HolidayVillageIcon,
  ScheduleIcon:ScheduleIcon,
  AnnouncementIcon:AnnouncementIcon,
  ShoppingBagIcon:ShoppingBagOutlinedIcon,
  CompareArrowsIcon:ImportExportIcon,
  FavoriteBorderIcon:FavoriteBorderIcon,
  SearchIcon:SearchIcon,
  BeenhereOutlinedIcon:BeenhereOutlinedIcon,
  SpaceDashboardIcon:SpaceDashboardIcon,
  AppsIcon:AppsIcon,
  FaListIcon:FaList,
  StrightWalkIcon:DirectionsWalkIcon,
  CycleIcon:DirectionsBikeIcon,
  ShoppingCartIcon:ShoppingCartIcon,
  ShoppingCartCheckoutIcon:ShoppingCartCheckoutIcon,
  CreditCardIcon:CreditCardIcon,
  DoneAllIcon:DoneAllIcon,
  PaymentsIcon:PaymentsIcon,
  ReceiptIcon:ReceiptIcon,
  AnalyticsIcon:AnalyticsIcon,
  ReportIcon:ReportIcon,
  TicketIcon:LocalActivityIcon,
  TimeClockIcon:AccessTimeIcon,
  StoreIcon:StorefrontIcon,
  RazorPayIcon:SiRazorpay,
  StudentIcon:PiStudent,
  NoShoppingCartIcon:RemoveShoppingCartIcon,
  DownloadIcon:DownloadIcon,
  ErrorOutlineIcon:ErrorOutlineIcon,
  ShoppingCartOutlinedIcon,
  ChevronRightIcon:ChevronRightIcon,
  CheckIcon:CheckBoxIcon,
  CheckCircleIcon:CheckCircleIcon,
  CancelIcon:CancelIcon,
  SaveIcon:SaveIcon,
  Print:PrintIcon,
  SyncIcon:SyncIcon,
  LocalShippingIcon:LocalShippingIcon
};
